import { Directive, HostListener, ElementRef, OnInit, AfterViewInit, SimpleChanges, Input, Renderer } from "@angular/core";
import { PercentPipe } from "./percent.pipe";

@Directive(
    {
        selector: "[PercentFormatter]"
    }
)
export class PercentFormatterDirective implements OnInit {

    private el: any;
    fractionSize: number
    @Input('options') options;
    constructor(
        private elementRef: ElementRef,
        private percentPipe: PercentPipe
    ) {
        this.el = this.elementRef.nativeElement;
    }

    ngOnInit() {
        setTimeout(() => {
            this.fractionSize = JSON.parse(JSON.stringify(this.options)).fractionSize
        }, 200)
    }

    @HostListener('change')
    ngOnChanges(changes: SimpleChanges) {
    }

    @HostListener("focus", ["$event.target.value"])
    onFocus(value) {
        this.el.value = this.percentPipe.parse(value, this.fractionSize); // opossite of transform        
        this.el.select()
    }

    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        this.el.value = this.percentPipe.transform(value, this.fractionSize)
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event) {

        let e = <KeyboardEvent>event;

        if (e.keyCode == 190) {
            e.preventDefault();
        }

        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

    }

}